import React from 'react';
import { bool, object, string } from 'prop-types';

import { styWaveV2 } from './styles';

/**
 * function to render Wave Version 2 component
 * @returns {JSX.Element}
 * @author idindrakusuma
 */
function Wave({ inverse, isWhiteColor, style, bgColor, isTransparent }) {
  return <div css={styWaveV2({ inverse, isWhiteColor, bgColor, isTransparent })} style={style} />;
}

Wave.propTypes = {
  bgColor: string,
  inverse: bool,
  isTransparent: bool,
  isWhiteColor: bool,
  style: object,
};

Wave.defaultProps = {
  bgColor: '#fff',
  inverse: false,
  isTransparent: false,
  isWhiteColor: false,
  style: {},
};

export default React.memo(Wave);
